module.exports = __webpack_public_path__ + "img/icon-grey-search.11dfe37e.svg";